import React from 'react';
import PremiumTableHeader from '../PremiumTableHeader/PremiumTableHeader';
import PremiumRow from '../PremiumRow/PremiumRow';

const PremiumTable = ({ calculatedPremiums, productCode, input, meta }) => {
  const handleSelectPremium = (schemeId) => {
    input.onChange([
      {
        id: schemeId,
      },
    ]);
  };

  // Standard schemes with no enhanced options.
  const noEnhancedSchemes = ['SC', 'PA', 'CC'];

  const selectedPremiumId = input.value[0] ? input.value[0].id : '';

  const title = productCode === 'SC' ? 'Surgery Cash Cover' : 'Standard Cover';

  return (
    <>
      <h3>{title}</h3>
      <PremiumTableHeader />
      {!calculatedPremiums.standard.length && <div>No Premiums found</div>}
      {calculatedPremiums.standard.map((premium) => (
        <PremiumRow
          premium={premium}
          coverLevel={premium.scheme.cover_level}
          handleSelectPremium={handleSelectPremium}
          selectedPremiumId={selectedPremiumId}
        />
      ))}

      <hr />
      {!noEnhancedSchemes.includes(productCode) && (
        <>
          <h3>Enhanced Cover</h3>
          <PremiumTableHeader />
          {!calculatedPremiums.enhanced.length && <div>No Premiums found</div>}
          {calculatedPremiums.enhanced.map((premium) => (
            <PremiumRow
              premium={premium}
              coverLevel={premium.scheme.cover_level}
              handleSelectPremium={handleSelectPremium}
              selectedPremiumId={selectedPremiumId}
            />
          ))}
        </>
      )}
      {meta && meta.touched && meta.error && (
        <span className="input-age-error">{meta.error}</span>
      )}
    </>
  );
};

export default PremiumTable;
